<script setup lang="ts">
import type { KsoPayControl } from "../ksoPayControls";

defineProps<{ control: KsoPayControl }>();
</script>

<template>
	<span class="kso_pay_label" v-bind="control.labelAttrs">{{ control.label }}</span>
	<span class="kso_pay_amount" v-bind="control.amountAttrs">{{ control.amount }}</span>
</template>
